export default __webpack_public_path__ + "static/media/InstagramOutline.3c77e627.svg";